module.exports = __webpack_public_path__ + "img/iot-hover.64f48ac1.png";